import { ProfileAccountInfo } from "api/interfaces/accountInterface.interface";
import { LEVEL_TYPE } from "api/interfaces/commonInterface.interface";
import AccountId from "components/atoms/text/labels/AccountId";
import styled from "styled-components";
import * as mediaQuery from "components/MediaQuery";
import { FLEX } from "styles/flex";
import { calcRem } from "styles/theme";

type Props = {
  info: ProfileAccountInfo & { level: LEVEL_TYPE };
};

export default function OrgInfoItem(props: Props): JSX.Element {
  const { info } = props;
  const companyLocation = (info.companyLocation || "")
    .split(",")
    .map((part) => part.trim())
    .filter(Boolean)
    .join(", ");

  return (
    <Wrapper>
      <ul className="meta">
        <li>
          <AccountId level={info.level} accountId={info.accountNumber} />
          <span>{info.name}</span>
        </li>
        <li>
          <label>Email</label>
          <span>{info.ownerEmail || "-"}</span>
        </li>
        {info.companyName && (
          <li>
            <label>Company</label>
            <span>{info.companyName}</span>
          </li>
        )}

        {companyLocation && (
          <li>
            <label>Company Address</label>
            <span>{companyLocation}</span>
          </li>
        )}
      </ul>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  width: 100%;
  ${FLEX.FlexStartCenter};
  flex-wrap: wrap;
  gap: 6px 28px;
  padding: 10px 16px;
  border-radius: 6px;
  background-color: ${({ theme }) => theme.COLORS.PRIMARY3};
  color: ${({ theme }) => theme.COLORS.WHITE};
  font-size: ${calcRem(14)};
  min-width: 0;
  line-height: 1.25;

  .meta {
    ${FLEX.FlexStartCenter};
    flex: 1;
    flex-wrap: wrap;
    gap: 6px 24px;
    min-width: 0;

    li {
      ${FLEX.FlexStartCenter};
      gap: 6px;
      min-width: 0;
    }
    label {
      opacity: 0.5;
      font-size: ${calcRem(12)};
      text-transform: uppercase;
      white-space: nowrap;
    }
    span {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  ${mediaQuery.isMobile} {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;

    .meta {
      flex-direction: column;
      align-items: flex-start;
      gap: 6px;

      span {
        white-space: normal;
      }
    }
  }
`;
